var HotSpotManager2D = {
	spots:[],
	playerWidth:0,
	playerHeight:0,
	lastMore:null,
	visiblility:false,

	add: function(spot) {
		this.spots.push(spot);		
	},

	addAll: function(data) {
				
		for(var spi in data) {
//			this.spots.push(new panoramaHotSpot(data[spi], spi, north));

			//console.log(data[spi]);

			if (data[spi].nomouse != "true") 
				var spot = new photoHotSpot(data[spi], spi);
				this.spots.push(spot);
		}
		
	},

	findById: function(id) {
		for(var s in this.spots) {
			if (parseInt(this.spots[s].properties.ident) == id) return this.spots[s];
		}

		return null;
	},
	
	hideWindow: function(e) {		
		if (HotSpotManager2D.lastMore != null) this.spots[HotSpotManager2D.lastMore].noMore();
	},
	
	more: function(k) {		
		if (HotSpotManager2D.lastMore != null) this.spots[HotSpotManager2D.lastMore].noMore();
		
		for(var spi in this.spots) {
			if (this.spots[spi].no == k) {
				//console.log("MORE " + k);
				this.spots[spi].more();
				HotSpotManager2D.lastMore = spi;
			}
		}			
	},
	
	process: function(pos, w, h) {
		//console.log(pos.left);
		for(var spi in this.spots) {
			this.spots[spi].process(pos.left, pos.top, w, h);
		}
	},

	clear: function() {
		for(var spi in this.spots) {
			this.spots[spi].remove();
		}
		
		HotSpotManager2D.lastMore = null;
		
		HotSpotManager2D.spots = [];
	},

	setVisibility: function(b) {
		HotSpotManager2D.visiblility = b;
		if (b) {
			$("#hotspots").show();
			//$(".hotspot").show();
		} else { 
			$("#hotspots").hide();
			//$(".hotspot").hide();
		}
	},

	setMobile: function(b) {
		if (b) {
			$("#hotspots .hotspot").addClass('hidden');
			$("#hotspots .primary").removeClass('hidden');
			$("#hotspots .primary").addClass('center');
			$("#hotspots .primary img").attr("width", "80");
			$("#hotspots .primary img").attr("height", "80");
			$("#hotspots .primary img").css("left", "-40px");
			$("#hotspots .primary img").css("top", "-40px");
			$("#hotspots .primary img").css("opacity", "1");
			$("#hotspots .primary .rest").css("position", "initial");
		} else {
			$("#hotspots .hotspot").removeClass('hidden');
			$("#hotspots .primary").removeClass('center');
		}
	},

	removeSpot: function(spot) {
		var found = -1;		
		for(var spi in this.spots) {
			if (this.spots[spi] == spot) {
				found = spi;
				break;
			}
		}
		if (found > -1) {
		//	this.spots[found].removeHelper();
			this.spots[found].remove();
			this.spots.splice(found, 1);
		}
	},
}
